import { PropsWithChildren } from "react";
import { ToastProvider } from "@commonlibs";
import QueryClientProvider from "./query/QueryClientProvider";
import { default as ConfigProvider } from "./config/ConfigProvider";
import ErrorHandler from "./common/components/feedback/ErrorHandler/ErrorHandler";

const Providers = ({ children }: PropsWithChildren<unknown>): JSX.Element => (
    <ConfigProvider>
        <ToastProvider>
            <ErrorHandler>
                <QueryClientProvider>{children}</QueryClientProvider>
            </ErrorHandler>
        </ToastProvider>
    </ConfigProvider>
);

export default Providers;
